<template>
  <div
    v-if="showContent"
    style="background: #ededed; display: grid; place-items: center; min-height: 100vh;"
  >
    <form class="login-form" @submit.prevent="submitFunc">
      <p style="color: #1d1d1d; font-size: 24px; font-weight: 600;">
        Відновлення паролю
      </p>

      <v-col class="px-0 py-0" v-if="!successMessage">
        <p class="login-form-field-name" style="margin-top: 15px">Email</p>
        <v-text-field
          outlined
          dense
          placeholder="Введіть email"
          v-model="user.email"
          :hide-details="!emailErrors.length"
          :error-messages="emailErrors"
        />
        <span class="error-message">{{ errorMessage }}</span>
        <admin-submit-button
          width="100%"
          :loading="isLoadingBtn"
          style="margin-top: 16px"
          type="submit"
        >
          Надіслати лист для відновлення
        </admin-submit-button>
      </v-col>

      <v-col v-else style="text-align: center">
        <div class="success-message">
          Лист успішно надіслано на пошту {{ user.email.substring(0, 3) }}***{{
            user.email.substring(user.email.length - 9)
          }}
          Перевірте свою пошту, а також папку "Спам".
        </div>
      </v-col>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import adminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";

Vue.use(Vuelidate);

export default {
  components: { adminSubmitButton },
  data() {
    return {
      showContent: true,
      user: { email: "" },
      errorMessage: "",
      successMessage: false,
      isLoadingBtn: false,
    };
  },
  validations: {
    user: {
      email: { required, email },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.user.email.$dirty) return errors;
      if (!this.$v.user.email.required) errors.push("Поле email не може бути порожнім.");
      if (!this.$v.user.email.email) errors.push("Поле email введено не коректно.");
      return errors;
    },
  },
  methods: {
    async submitFunc() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isLoadingBtn = true;

      try {
        // Тут повинен бути твій API виклик для відновлення паролю
        // const res = await axios.post('/api/forgot-password', this.user)
        console.log("Відправка листа для:", this.user.email);

        localStorage.setItem("photobook_email", this.user.email);
        this.successMessage = true;
      } catch (err) {
        this.errorMessage = "* Користувача з таким емейлом не існує";
      } finally {
        this.isLoadingBtn = false;
      }
    },
  },
};
</script>

<style scoped>
.login-form {
  font-family: Rubik;
  padding: 30px;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  width: 463px;
}
.login-form-field-name {
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.success-message {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #b7dfc8;
  background: #e9f7ef;
  padding: 14px 10px;
  color: #516a4f;
  font-family: Rubik;
  font-size: 14px;
}
.error-message {
  color: red;
  font-size: 12px;
}
</style>
